import { format } from 'date-fns';

export const getTime = (recorded: number, index: number) =>
  format(recorded + (index / 200) * 1000, 'yyy-MM-dd - HH:mm:ss');
